<template>
  <div class="upload-center" :class="{'upload-successful-page': !showFilesUploadForm}">
    <div v-show="showFilesUploadForm" class="acc-page-holder">
      <h1>{{ $t('Account.UploadCenter.Title') }}</h1>
      <div class="acc-upload-center">
        <p class="disclaimer">{{ $t('Account.UploadCenter.Disclaimer') }}</p>
        <FilesUploadForm @files-upload-successful="showFilesUploadForm = false" @all-files-uploaded="onAllFilesUploaded" :numberOfFiles="documentsUploadLimit"  />
      </div>
    </div>
    <UploadSuccessfulScreen v-show="!showFilesUploadForm" @add-more-files="showFilesUploadForm = true" :allFilesUploaded="allFilesUploaded" />
  </div>
</template>

<script>
import store from '@/store'
import FilesUploadForm from './FilesUploadForm.vue'
import UploadSuccessfulScreen from './UploadSuccessfulScreen.vue'

export default {
  name: 'UploadCenter',
  components: {
    FilesUploadForm,
    UploadSuccessfulScreen
  },
  data () {
    return {
      showFilesUploadForm: true,
      allFilesUploaded: false
    }
  },
  computed: {
    documentsUploadLimit () {
      return store.getters['getDocumentsUploadLimit']
    }
  },
  methods: {
    onAllFilesUploaded (value) {
      this.allFilesUploaded = value
    }
  }
}
</script>

<style scoped>
.upload-center.upload-successful-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.acc-upload-center {
  background:  var(--account-summary-boxes-bgr);
  border-radius: var(--account-summary-boxes-border-radius);
  color: var(--account-pages-infomsg-default-color);
}
.disclaimer {
  padding: 10px;
  margin: 0;
  font-family: 'Roboto Condensed'
}
</style>



// WEBPACK FOOTER //
// src/components/account/UploadCenter/UploadCenter.vue